import { ImpersonationOverlay } from '@components/impersonation-overlay';
import { RootLayout } from '@components/layout';
import { PageLoader } from '@components/ui/PageLoader';
import { getAuthRedirect, useAuthContext } from '@features/auth';
import { useImpersonationLayout } from '@shared/api/impersonation';
import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedLayout = () => {
  const { impersonationToken } = useImpersonationLayout();
  const { isAuthorized, isLoading } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader className="h-screen w-screen" />;
  }

  if (!isAuthorized && !impersonationToken) {
    return (
      <Navigate
        to={getAuthRedirect(location.pathname, location.search)}
        replace
      />
    );
  }

  return (
    <>
      <RootLayout />
      <ImpersonationOverlay isActive={!!impersonationToken} />
    </>
  );
};
